import React, { useEffect } from "react";
import CourseCard from "../../../Components/AllCourseCard/CourseCard";
import PricingCards from "../../Home/PricingCards";
import "./NooraniQaida.css";
import img from "../../../Assets/8.png";
// import FreeTrail from "../../../Components/3DaysTrail/FreeTrail";
import CourseFeatures from "../../../Components/CourseFeatures/CourseFeatures";
import AOS from "aos";
const NooraniQaida = () => {
  useEffect(() => {
    document.title = "Noorani Qaida";

    AOS.init({
      duration: 3000,
    });
  });
  return (
    <>
      <div className="container-fluid bg-img-1 text-center">
        <h1 className="main-1-heading">
          {" "}
          Basic Qaida For <br /> Beginners
        </h1>
      </div>
      <div className="container mt-5">
        <div className="row">
          <div className="col-sm-12 col-lg-6">
            <div className="course-data">
              <h1 className="main-data-heading">Basic Qaida For Beginners</h1>

              <p className="main-data-para">
                Learning Noorani Qaida is a great way to start learning how to
                read the Quran with proper pronunciation and Tajweed rules. It's
                a foundational book that helps beginners understand the Arabic
                alphabet, basic pronunciation rules, and essential Tajweed
                principles. It's widely used in many Islamic educational
                institutions and is beneficial for both children and adults who
                are starting to learn Quranic recitation. At our academy, we
                offer comprehensive Noorani Qaida courses designed to cater to
                learners of all levels, from beginners to advanced students. We
                cover essential topics such as Arabic alphabet recognition,
                pronunciation rules, Tajweed principles, and Quranic reading
                fluency. With experienced instructors, personalized attention,
                and interactive learning materials, we ensure that students
                develop a strong foundation in Noorani Qaida, enabling them to
                embark confidently on their journey towards Quranic mastery.
              </p>
              <p className="main-data-para">
                The Noorani Qaida typically follows a structured outline to
                teach beginners how to read the Quran. Here's a basic outline
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-lg-6">
            <img src={img} alt="" className="img1" />
          </div>
        </div>
      </div>

      <div className="container mt-5">
        <div className="row mt-5">
          <div className="col-sm-12 col-lg-6">
            <ul className="ul" data-aos="fade-right">
              <li className="li">
                <h2 className="h2-main mt-3"> Harakaat (Short Vowels):</h2>
                <p className="p-main">
                  Learners are introduced to the three short vowels (fatha,
                  kasra, and damma) and how they affect the pronunciation of
                  letters.
                </p>
              </li>
              <li className="li">
                <h2 className="h2-main">Tanween and Noon Sakinah Rules:</h2>
                <p className="p-main">
                  This section teaches the rules related to the pronunciation of
                  the noon sakinah (3) and tanween (-) with different letters.
                </p>
              </li>
              <li className="li">
                <h2 className="h2-main"> Madd Rules:</h2>
                <p className="p-main">
                  Learners are introduced to the rules of prolongation (madd) in
                  recitation, including madd tabee'i (natural prolongation) and
                  madd munfasil (separated prolongation).
                </p>
              </li>
              <li className="li">
                <h2 className="h2-main"> Sukoon and Shaddah Rules:</h2>
                <p className="p-main">
                  This section covers the rules related to sukoon () and shaddah
                  (), explaining how they affect the pronunciation of letters.
                </p>
              </li>
            </ul>
          </div>
          <div className="col-sm-12 col-lg-6">
            <ul data-aos="fade-right">
              <li className="li">
                <h2 className="h2-main">Tajweed Rules</h2>
                <p className="p-main">
                  Basic Tajweed rules are introduced, such as idghaam (merging),
                  ikhfaa (concealing), and rules related to the pronunciation of
                  specific letter
                </p>
              </li>
              <li className="li">
                <h2 className="h2-main">Practice Exercises:</h2>
                <p className="p-main">
                  Throughout the book, there are exercises and practice sections
                  to reinforce learning and help learners apply the rules they
                  have learned.
                </p>
              </li>
              <li className="li">
                <h2 className="h2-main"> Reading Exercises:</h2>
                <p className="p-main">
                  Towards the end of the book, there are reading exercises where
                  learners can practice reading Quranic verses using the rules
                  they have learned.
                </p>
              </li>
              <li className="li">
                <h2 className="h2-main">Revision and Mastery:</h2>
                <p className="p-main">
                  The final sections of the Noorani Qaida often include revision
                  exercises and tips for continued practice to ensure mastery of
                  the material.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container">
        <h1 className=" h1-heading text-center mt-4">
          In the Reading Noorani Qaida Basics <br /> course, you’ll learn:
        </h1>
        <div className="row">
          <div className="col-sm-12 col-lg-6">
            <ul className="card-content ms-4">
              <li className="lists">The Arabic Alphabet</li>
              <li className="lists">Arabic diacritics</li>
              <li className="lists">Letters Forms</li>
              <li className="lists">Vowels</li>
              <li className="lists">Sukun</li>
            </ul>
          </div>
          <div className="col-sm-12 col-lg-6">
            <ul className="card-content ms-4">
              <li className="lists">Shaddah</li>
              <li className="lists">Madd – Lengthening</li>
              <li className="lists">Shaddah with Tanween</li>
              <li className="lists">Laam rules</li>
              <li className="lists">AlifulWasl rules</li>
              {/* <li className="lists">
                  Characteristics of the Quranic writing
                </li> */}
            </ul>
          </div>
        </div>
      </div>

      <CourseFeatures />
      <CourseCard />
      <PricingCards />
    </>
  );
};

export default NooraniQaida;
